<template>
  <div class="row justify-content-end">
    <div class="auth-language-select-wrap">
      <select-lang class="auth-language-select" @change:language="change_language" />
    </div>
  </div>
</template>
<script>
  import SelectLang from '@shared/components/select-lang';
  import { mapActions } from 'vuex';

  export default {
    components: { SelectLang },
    methods: {
      ...mapActions('core/auth', ['setFrontendLocale']),

      change_language: function(name) {
        this.setFrontendLocale(name);
      }
    }
  };
</script>
<style lang="scss">
  .auth-language-select {
    &-wrap {
      width: 80px;
      height: 80px;
      border-radius: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      &:hover {
        background-color: #586e82;
      }
    }
    .ivu-select-dropdown {
      top: 56px !important;
      left: -62px !important;
    }
    position: absolute;
  }
</style>
